export default function NoteItem({ note, onEdit, onDelete, showFolder, selectable }) {
  return (
    <tr style={onEdit ? { cursor: 'pointer' } : undefined} onClick={onEdit ? () => onEdit(note) : undefined}>
      <td className="ps-0" style={{ width: 24 }}></td>
      <td>
        <span className="badge bg-info text-dark" style={{ fontSize: '0.65rem' }}>Note</span>
      </td>
      <td></td>
      <td>
        <div className="fw-semibold">{note.name}</div>
      </td>
      {showFolder && <td><small>{note.folder_name}</small></td>}
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      {onDelete && (
        <td onClick={(e) => e.stopPropagation()}>
          <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(note.id)}>Delete</button>
        </td>
      )}
      {selectable && <td></td>}
    </tr>
  );
}
